import { companyDetails } from "../data";

export default function FloatingCTA() {
  const phoneClean = companyDetails.phone.replace(/\s+/g, "");

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3 items-end pointer-events-none">
      {/* LinkedIn Button */}
      <a
        href={companyDetails.socials.linkedin}
        target="_blank"
        rel="noopener noreferrer"
        className="pointer-events-auto group relative flex items-center justify-end w-12 hover:w-32 h-12 bg-white hover:bg-navy-50 text-[#0a66c2] rounded-full shadow-lg border border-gray-100 transition-all duration-300 ease-in-out"
        title="LinkedIn"
        aria-label="Besøg os på LinkedIn"
      >
        <span className="absolute right-12 opacity-0 group-hover:opacity-100 translate-x-2 group-hover:translate-x-0 transition-all duration-300 ease-in-out text-xs font-semibold text-gray-700 whitespace-nowrap pointer-events-none">
          LinkedIn
        </span>
        <div className="absolute right-[14px] w-5 h-5 flex items-center justify-center shrink-0">
          <i className="fa-brands fa-linkedin-in text-lg" />
        </div>
      </a>

      {/* Facebook Button */}
      <a
        href={companyDetails.socials.facebook}
        target="_blank"
        rel="noopener noreferrer"
        className="pointer-events-auto group relative flex items-center justify-end w-12 hover:w-32 h-12 bg-white hover:bg-navy-50 text-[#1877f2] rounded-full shadow-lg border border-gray-100 transition-all duration-300 ease-in-out"
        title="Facebook"
        aria-label="Besøg os på Facebook"
      >
        <span className="absolute right-12 opacity-0 group-hover:opacity-100 translate-x-2 group-hover:translate-x-0 transition-all duration-300 ease-in-out text-xs font-semibold text-gray-700 whitespace-nowrap pointer-events-none">
          Facebook
        </span>
        <div className="absolute right-[14px] w-5 h-5 flex items-center justify-center shrink-0">
          <i className="fa-brands fa-facebook-f text-lg" />
        </div>
      </a>

      {/* Mail Button */}
      <a
        href={`mailto:${companyDetails.email}`}
        className="pointer-events-auto group relative flex items-center justify-end w-12 hover:w-32 h-12 bg-white hover:bg-navy-50 text-brand-orange hover:text-brand-orange-hover rounded-full shadow-lg border border-gray-100 transition-all duration-300 ease-in-out"
        title="Send e-mail"
        aria-label="Send e-mail"
      >
        <span className="absolute right-12 opacity-0 group-hover:opacity-100 translate-x-2 group-hover:translate-x-0 transition-all duration-300 ease-in-out text-xs font-semibold text-gray-700 whitespace-nowrap pointer-events-none">
          E-mail
        </span>
        <div className="absolute right-[14px] w-5 h-5 flex items-center justify-center shrink-0">
          <i className="fa-solid fa-envelope text-lg" />
        </div>
      </a>

      {/* Phone Button */}
      <a
        href={`tel:+45${phoneClean}`}
        className="pointer-events-auto group relative flex items-center justify-end w-12 hover:w-32 h-12 bg-brand-orange hover:bg-brand-orange-hover text-white rounded-full shadow-lg transition-all duration-300 ease-in-out"
        title="Ring op"
        aria-label="Ring til os"
      >
        <span className="absolute right-12 opacity-0 group-hover:opacity-100 translate-x-2 group-hover:translate-x-0 transition-all duration-300 ease-in-out text-xs font-semibold text-white whitespace-nowrap pointer-events-none">
          Ring op
        </span>
        <div className="absolute right-[14px] w-5 h-5 flex items-center justify-center shrink-0">
          <i className="fa-solid fa-phone text-lg" />
        </div>
      </a>
    </div>
  );
}
